const Footer = () => (
  <footer className="bg-white border-top text-center py-2 small">
    © 2025 Designed By Zentelex PVT. LTD. All rights reserved.
  </footer>
);

export default Footer;
